var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.values');
    };
  };
};

export default createGetFormValues;


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/selectors/getFormValues.js
// module id = 2077
// module chunks = 0